export default __webpack_public_path__ + "static/media/Snail.4245cc2d.svg";